export default {"src":"/_next/static/media/calander.ac5b22b9.svg","height":132,"width":86,"blurWidth":0,"blurHeight":0};